// NotFound.styles.js
import styled from "styled-components";

export const Container = styled.div`
  height: calc( 100vh - ( var( --navbar-height) + var(--footer-height) ) );;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: padding: var(--general-padding);
`;

export const Icons = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const Highlight = styled.span`
  color: ${(props) => props.theme.colorPri404};
`;

export const Text = styled.p`
  font-size: 1.2rem;
  max-width: 600px;
  margin-bottom: 20px;
`;
